/* 囲み付き文字列 */
import React from 'react';
import { convertLine } from '../Convert';

interface Props {
  label: string;
  bold?: boolean;
  color?: string;
  css_class?: string;
  is_new_line?: boolean;
  size: 's' | 'm' | 'l';
}
const Heading: React.FC<Props> = ({
  label,
  bold,
  color = 'text-dark',
  css_class = '',
  is_new_line,
  size,
}) => {
  //太字の規定値
  const bold_css = typeof bold !== 'undefined' && bold === true ? 'font-weight-bold' : '';

  return (
    <div
      className={`heading-${size} ${bold_css} ${color} ${css_class} ${
        is_new_line ? 'new-line' : ''
      }`}
    >
      {convertLine(label)}
    </div>
  );
};

export default Heading;
